import { Pipe, PipeTransform } from '@angular/core';
import { NotificationResults } from '../../header/notifications-menu/notifications-menu.viewmodel';

@Pipe({
  name: 'unreadNotifications',
  standalone: true
})
export class UnreadNotificationsPipe implements PipeTransform {

  transform(notifications: NotificationResults[]): NotificationResults[] {
    return notifications?.filter(item => !item.isRead);
  }

  transformIdArray(notifications: NotificationResults[]): string[] {
    return notifications.map(item => item.id.toString());
  }


}
